import { render, staticRenderFns } from "./PostForm.vue?vue&type=template&id=4402b8bf"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4402b8bf')) {
      api.createRecord('4402b8bf', component.options)
    } else {
      api.reload('4402b8bf', component.options)
    }
    module.hot.accept("./PostForm.vue?vue&type=template&id=4402b8bf", function () {
      api.rerender('4402b8bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/post/PostForm.vue"
export default component.exports